// extracted by mini-css-extract-plugin
module.exports = {"container":"DragTextHolder_container__4XCIO","correctHit":"DragTextHolder_correctHit__x22vJ","incorrectHit":"DragTextHolder_incorrectHit__1ru18"};